import { render } from "./CookiePolicyPage.vue?vue&type=template&id=643ae486"
import script from "./CookiePolicyPage.vue?vue&type=script&lang=js"
export * from "./CookiePolicyPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__